export const usersApiErrors: Record<string, string> = {
  NOT_FOUND: 'userNotFound',
  FORBIDDEN: 'ownUserEditForbidden',
};

export const deleteUserErrors: Record<string, string> = {
  NOT_FOUND: 'userNotFound',
  FORBIDDEN: 'ownUserDeleteForbidden',
};
